__turbopack_context__.v({
  "buttonMore": "vXUJMa_buttonMore",
  "commentAuthor": "vXUJMa_commentAuthor",
  "commentAvatar": "vXUJMa_commentAvatar",
  "commentContainer": "vXUJMa_commentContainer",
  "commentContent": "vXUJMa_commentContent",
  "commentDate": "vXUJMa_commentDate",
  "commentHeader": "vXUJMa_commentHeader",
});
